import Swiper from "../../../vendors/swiper.min";
export const photoCarousel = {
    init: function() {
        const photoCarusel = document.querySelectorAll(".photoCarousel");
        const photoSwiper = document.querySelectorAll(".photo-carousel-swiper");
        if (!photoCarusel && !photoSwiper) return;

        photoCarusel.forEach(singleCarousel => {
            const photoCaruselImg = singleCarousel.querySelectorAll(
                ".photo-carousel__img"
            );
            const photoCaruselSlides = singleCarousel.querySelectorAll(
                ".photo-carousel__slide"
            );
            this.cloneSlides(photoCaruselImg, photoCaruselSlides, singleCarousel);
            this.checkIfHorizontal(singleCarousel);
            this.eventListenersAssignment(singleCarousel);
            this.slickInital(singleCarousel, photoCaruselImg);
        });
        this.initSwiper();
    },
    initSwiper: function() {
        const photoSwiper = document.querySelectorAll(".swiper-wrapper");
        const photoCarouselSwiper = document.querySelectorAll(
            ".photo-carousel-swiper"
        );
        const that = this;
        var mySwiper = new Swiper(".photo-carousel-swiper", {
            // Optional parameters
            observer: true,
            init: false,
            centeredSlides: true,
            loop: true,
            // loopedSlides: 100,
            // loopAdditionalSlides: 4,
            slidesPerView: 5,
            slidesPerGroup: 1,
            breakpoints: {
                767: {
                    slidesPerView: 1
                },
                991: {
                    slidesPerView: 3
                }
            },

            // Navigation arrows
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });
        mySwiper.on("init", () => {
            this.changeImagesSizeClass(true);
            photoSwiper.forEach(singleCarousel => {
                this.checkIfHorizontal(singleCarousel);
            });
        });
        mySwiper.on("transitionStart", () => {
            this.changeImagesSizeClass(true);
        });
        if (photoCarouselSwiper.length) {
            mySwiper.init();
        }
        $(window).resize(function() {
            that.changeImagesSizeClass(true);
            photoSwiper.forEach(singleCarousel => {
                that.checkIfHorizontal(singleCarousel);
            });
            if (photoCarouselSwiper.length) {
                mySwiper.slideToLoop(0);
                mySwiper.update();
            }
        });
    },
    slickInital: function(photoCarusel, photoCaruselImg) {
        const prevArrowEl =
            '<button type="button" class="button-b2c bg--blue button-b2c--circle button-b2c--with-arrow check-availability-2__btn check-availability-2__btn--arrow right-slider-arrow"><span class="sr-only">' +
            photoCarusel.getAttribute("data-text-prev") +
            "</span></button>";
        const nextArrowEl =
            '<button type="button" class="button-b2c bg--blue button-b2c--circle button-b2c--with-arrow check-availability-2__btn check-availability-2__btn--arrow left-slider-arrow"><span class="sr-only">' +
            photoCarusel.getAttribute("data-text-next") +
            "</span></button>";
        $(photoCarusel).slick({
            centerMode: true,
            accessibility: false,
            prevArrow: prevArrowEl,
            nextArrow: nextArrowEl,
            centerPadding: "none",
            responsive: [{
                    breakpoint: 9999,
                    settings: {
                        slidesToShow: this.checkNumberOfSlides(photoCaruselImg),
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerPadding: "none"
                    }
                }
            ]
        });
    },
    checkIfHorizontal: function(singleSlide) {
        const element = singleSlide.querySelectorAll(".photo-carousel__img");
        element.forEach(el => {
            let imageUrl = getComputedStyle(el)["background-image"];
            let image;
            const regex = /^url\("?(.+?)"?\)$/;
            imageUrl = imageUrl.match(regex);

            if (imageUrl[1]) {
                imageUrl = imageUrl[1];
                image = new Image();
                image.addEventListener("load", _ => {
                    if (image.width > image.height) {
                        el.classList.add("horizontal");
                    }
                });
                image.src = imageUrl;
            }
        });
    },
    changeImagesSizeClass: function(withRemove) {
        const carouselWrapper = document.querySelectorAll(".photo-carousel__wrapper");
        if (withRemove) {
            carouselWrapper.forEach(el => {
                el.classList.remove("mid-image-right");
                el.classList.remove("mid-image-left");
                el.classList.remove("sm-image-right");
                el.classList.remove("sm-image-left");
            });
        }
        $(".slick-center, .swiper-slide-active")
            .prev()
            .children(".photo-carousel__wrapper")
            .addClass("mid-image-left");
        $(".slick-center, .swiper-slide-active")
            .next()
            .children(".photo-carousel__wrapper")
            .addClass("mid-image-right");
        $(".slick-center, .swiper-slide-active")
            .prev()
            .prev()
            .children(".photo-carousel__wrapper")
            .addClass("sm-image-left");
        $(".slick-center, .swiper-slide-active")
            .next()
            .next()
            .children(".photo-carousel__wrapper")
            .addClass("sm-image-right");
    },
    eventListenersAssignment: function(photoCarousel) {
        $(photoCarousel).on("swipe", _ => {
            this.changeImagesSizeClass(true);
        });

        $(photoCarousel).on("init", _ => {
            this.changeImagesSizeClass();
            $(".photoCarousel .slick-arrow").on("click", () => {
                this.changeImagesSizeClass(true);
            });
        });
    },
    cloneSlides: function(photoCaruselImg, photoCaruselSlides, photoCarusel) {
        if (photoCaruselImg.length === 3 || photoCaruselImg.length === 5) {
            photoCaruselSlides.forEach(el => {
                const clonedEl = el.cloneNode(true);
                photoCarusel.appendChild(clonedEl);
            });
        }
    },
    checkNumberOfSlides: function(photoCaruselImg) {
        return photoCaruselImg.length >= 5 ? 5 : 3;
    }
};